// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Gp-z","slideIn":"Hp-z"};